import { useEffect, useState } from "react";

/**
 * Breakpoint único de nav-chrome do projeto (= `lg` do Tailwind). Mantém
 * sincronizado com globals.css (.admin-topbar-desktop-only) e com os
 * helpers hideInMobile/hideInDesktop de player-list-options — os três
 * decidiam sozinhos (960/1000px) e abriam uma faixa morta onde a nav
 * desaparecia dos dois lados.
 */
export const NAV_BREAKPOINT = 1024;

const MOBILE_BOTTOM_NAV_CONTENT_HEIGHT = "3.3125rem";

/** Offset compartilhado pelas barras fixas que ficam acima da bottom nav. */
export function getMobileBottomNavOffsetCss() {
  return `calc(${MOBILE_BOTTOM_NAV_CONTENT_HEIGHT} + max(env(safe-area-inset-bottom), 8px))`;
}

export function useIsMobile() {
  // false no servidor e no 1º paint: SSR não conhece a largura real da tela,
  // e window.matchMedia não existe nesse momento.
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${NAV_BREAKPOINT - 1}px)`);

    // Sincroniza assim que monta no client — evita renderizar 1 frame com o
    // valor inicial (false) quando a tela já é mobile.
    setIsMobile(mql.matches);

    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
